module.exports = __webpack_public_path__ + "assets/img/pt-f6bd8448.png";